import 'custom-event-polyfill';

import { renderTemplate } from './utilities';
import template from '../templates/global-menu-button.tpl.html';
import caretIcon from '../assets/images/icons/caret-down.svg';

export default class GlobalMenuButton {

  constructor(menuInstance, element, options, defaultOptions) {
    Object.assign(this, options);

    this.menuInstance = menuInstance;
    this.element = element;
    this.caretIcon = caretIcon;

    this.render(template, defaultOptions);
    this.observe();

    menuInstance.buttons.push(this);
  }

  render(template) {
    const renderedTemplate = renderTemplate(template, this);

    this.element.innerHTML = ''; // Clear the wrapping element...
    this.element.classList.add('dt-gnm-menu-button');
    this.element.appendChild(renderedTemplate);
  }

  observe() {
    this._clickListener = this.onClick.bind(this);
    this.element.addEventListener('click', this._clickListener);
  }

  destroy() {
    this.element.removeEventListener('click', this._clickListener);
    this._clickListener = null;
  }

  onClick(event) {
    event.stopPropagation();
    this.isOpen ? this.close() : this.open();
  }

  open() {
    this.element.classList.add('open');
    this.menuInstance.open(this);
    var event = new CustomEvent('gnm-button.open');
    this.element.dispatchEvent(event);
  }

  close() {
    this.menuInstance.close(this);
    this.element.classList.remove('open');
    var event = new CustomEvent('gnm-button.close');
    this.element.dispatchEvent(event);
  }

  get isOpen() {
    return this.element.classList.contains('open');
  }

  get cssClass() {
    return 'global-menu';
  }

  get menuItems() {
    return [];
  }
}



// WEBPACK FOOTER //
// ./src/scripts/global-menu-button.js